import { DeleteOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { observer } from "mobx-react-lite";
import * as React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { deleteClass } from "src/business/classes";
import { onError } from "src/common/onError";
import { DeleteConfirm } from "src/components/DeleteConfirm";
import { LoaderBox } from "src/components/LoaderBox";
import { msgQueueStore } from "src/components/MsgQueue";
import { PageBlocker } from "src/components/PageBlocker";
import { PageLayout } from "src/components/PageLayout";
import { makeUrl } from "src/routes/makeUrl";
import { PageUrl } from "src/routes/PageUrl";

import { ClassCardMForm } from "../ClassCardMForm";
import * as styles from "./EditClassPage.module.less";
import {
  EditClassData,
  editClassPageStore as pageStore,
} from "./editClassPageStore";

export const EditClassPage: React.FC = observer(() => {
  const { id = "" } = useParams();
  React.useEffect(() => {
    pageStore.init(id).catch(onError);
  }, [id]);
  return (
    <PageLayout title={pageStore.breadcrumbs}>
      <LoaderBox
        remoteData={pageStore.data}
        drawReady={(data) => <Inner data={data} />}
      />
    </PageLayout>
  );
});

const Inner: React.FC<{ data: EditClassData }> = observer(({ data }) => {
  const navigate = useNavigate();
  const doDelete = async () => {
    await deleteClass(data.classData.id);
    pageStore.form.setAsUnchanged();
    const targetUrl = data.classData.classifier?.id
      ? makeUrl(PageUrl.classes, { id: data.classData.classifier.id })
      : makeUrl(PageUrl.classifiers);
    navigate(targetUrl, {
      replace: true,
    });
  };
  const { permissions = {} } = data.classData;
  const readOnly = !permissions.canUpdate;
  const { root } = pageStore.form;
  React.useEffect(() => {
    root.setDisabled(readOnly);
  }, [readOnly, root]);
  return (
    <div className={styles.mainBox}>
      <PageBlocker changed={() => pageStore.form.isChanged} />
      <ClassCardMForm
        title={data.classData.name}
        okText="Сохранить"
        form={pageStore.form}
        errorsStore={pageStore.errorsStore}
        save={() => pageStore.save()}
        onSuccess={() =>
          msgQueueStore.add({ type: "info", message: "Данные сохранены" })
        }
        onSecondarySpecsChanged={(newList) =>
          pageStore.onSecondarySpecsChanged(newList)
        }
        readOnly={readOnly}
        extraButtons={
          <>
            {!!permissions.canDelete && (
              <Button
                icon={<DeleteOutlined />}
                danger
                onClick={() => pageStore.setMode("delete")}
              >
                Удалить
              </Button>
            )}
            <DeleteConfirm
              content="Удалить данный класс?"
              open={pageStore.mode === "delete"}
              close={() => pageStore.setMode(null)}
              successMsg="Выполнено удаление класса"
              task={doDelete}
            />
          </>
        }
      />
    </div>
  );
});
